export default "__VITE_ASSET__Bw4PPnbf__"